<template>
  <div>
    <template v-if="!isFromUserDeatil">
      <el-row :gutter="5">
        <el-form ref="params" :model="params" :rules="rules">
          <el-col :span="5" :xs="24">
            <SearchByMemberAndCard2 ref="SearchByMemberAndCard2" />
          </el-col>
          <!--        <el-col :span="5" :xs="24">-->
          <!--          <el-form-item prop="memberId">-->
          <!--            <el-select v-model="params.memberId"-->
          <!--                       :loading="userLoad"-->
          <!--                       :remote-method="getUserList"-->
          <!--                       filterable-->
          <!--                       placeholder="输入手机号选择用户"-->
          <!--                       remote-->
          <!--                       id="el-select"-->
          <!--                       @focus="closeReadOnly"-->
          <!--                       @hook:mounted="closeReadOnly"-->
          <!--                       @visible-change="closeReadOnly"-->
          <!--                       reserve-keyword>-->
          <!--              <el-option-->
          <!--                  v-for="item in userList"-->
          <!--                  :key="item.value"-->
          <!--                  :label="item.nickName"-->
          <!--                  :value="item.id">-->
          <!--                <img :src="item.headImage" alt="" class="img">-->
          <!--                <span style="margin-left: 10px">{{ item.nickName }}</span>-->
          <!--                <span style="margin-left: 10px">{{ item.money }}</span>-->
          <!--              </el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <!--        </el-col>-->
          <el-col :span="2" :xs="12">
            <el-button type="primary" @click="search">搜索</el-button>
          </el-col>
          <el-col :span="2" :xs="12">
            <el-button plain type="success" @click="reset">重置</el-button>
          </el-col>
        </el-form>
      </el-row>

      <el-row style="margin: 10px 0">
        <el-col :span="3" :xs="12">
          <el-button type="primary" @click="handleAddChargeMonthlyUserBtnClick"
            >新增充电包月用户</el-button
          ></el-col
        >
      </el-row>
    </template>

    <el-table
      v-loading="loadTable"
      :data="records"
      stripe
      @sort-change="sort_change"
    >
      <el-table-column fixed label="用户昵称" width="150">
        <template #default="scope">
          <el-tooltip
            effect="dark"
            :content="scope.row.user.name"
            placement="top-start"
          >
            <div class="text_ellipsis_1">
              {{ scope.row.user.name }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="手机号码/电卡" width="140">
        <template #default="scope">
          <el-tooltip
            effect="dark"
            :content="
              phoneOrCard(scope.row) === '0' ? '未绑定' : phoneOrCard(scope.row)
            "
            placement="top-start"
          >
            <div class="text_ellipsis_1">
              {{
                phoneOrCard(scope.row) === "0"
                  ? "未绑定"
                  : phoneOrCard(scope.row)
              }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="用户类型" prop="memberType" width="100">
        <template #default="scope">
          <span v-if="scope.row.memberType == '1'">微信</span>
          <span v-if="scope.row.memberType == '3'">电卡</span>
          <span v-if="scope.row.memberType == '7'">支付宝</span>
        </template>
      </el-table-column>
      <el-table-column label="包月类型" width="130">
        <template #default="scope">
          {{
            scope.row.type == 1
              ? "充电"
              : scope.row.type == 2
              ? "充电+停车"
              : "只停车"
          }}
        </template>
      </el-table-column>
      <el-table-column label="小区名称" prop="source.name" width="150">
        <template #default="scope">
          <el-tooltip
            effect="dark"
            :content="scope.row.source.name"
            placement="top-start"
          >
            <div class="text_ellipsis_1">
              {{ scope.row.source.name }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="最大功率" width="100">
        <template #default="scope">
          <template v-if="scope.row.source.endPower">
            {{ scope.row.source.endPower }}瓦
          </template>
        </template>
      </el-table-column>
      <el-table-column
        label="充电剩余时长"
        prop="source.freeChargeNum"
        width="130"
      />
      <el-table-column label="车库名称" width="140">
        <template #default="scope">
          <template v-if="scope.row.type == 2">
            <el-tooltip
              effect="dark"
              :content="
                scope.row.source.carportMemberMonthly.memberCar &&
                scope.row.source.carportMemberMonthly.memberCar.carport &&
                scope.row.source.carportMemberMonthly.memberCar.carport.name
              "
              placement="top-start"
            >
              <div class="text_ellipsis_1">
                {{
                  scope.row.source.carportMemberMonthly.memberCar &&
                  scope.row.source.carportMemberMonthly.memberCar.carport &&
                  scope.row.source.carportMemberMonthly.memberCar.carport.name
                }}
              </div>
            </el-tooltip>
          </template>
          <template v-if="scope.row.type == 3">
            <el-tooltip
              effect="dark"
              :content="
                scope.row.source.memberCar &&
                scope.row.source.memberCar.carport &&
                scope.row.source.memberCar.carport.name
              "
              placement="top-start"
            >
              <div class="text_ellipsis_1">
                {{
                  scope.row.source.memberCar &&
                  scope.row.source.memberCar.carport &&
                  scope.row.source.memberCar.carport.name
                }}
              </div>
            </el-tooltip>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="车牌号" width="100">
        <template #default="scope">
          <template v-if="scope.row.type == 2">{{
            scope.row.source.carportMemberMonthly.memberCar &&
            scope.row.source.carportMemberMonthly.memberCar.plateNumber
          }}</template>
          <template v-if="scope.row.type == 3">{{
            scope.row.source.memberCar && scope.row.source.memberCar.plateNumber
          }}</template>
        </template>
      </el-table-column>

      <el-table-column label="充电到期" prop="source.endTime" width="110">
        <template #default="scope">
          <template v-if="scope.row.type != 3">{{
            parseFormatDay(new Date(scope.row.source.endTime * 1000))
          }}</template>
        </template>
      </el-table-column>
      <el-table-column
        label="停车到期"
        prop="source.carportMemberMonthly.endTime"
        width="110"
      >
        <template #default="scope">
          <template
            v-if="scope.row.type == 2 && scope.row.source.carportMemberMonthly"
            >{{
              parseFormatDay(
                new Date(scope.row.source.carportMemberMonthly.endTime * 1000)
              )
            }}</template
          >
          <template v-if="scope.row.type == 3">{{
            parseFormatDay(new Date(scope.row.source.endTime * 1000))
          }}</template>
        </template>
      </el-table-column>

      <el-table-column label="包月状态" width="150">
        <template #default="scope">
          {{ scope.row.source.canceled == 1 ? "套餐变动,无法续费" : "正常" }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="140">
        <template #default="scope">
          <el-button size="mini" @click="handleEditMonthlyDate(scope.row)"
            >修改包月信息</el-button
          >

          <!-- <el-button size="mini" @click="clickEditEndLine(scope.row)"
            >修改结束日期</el-button
          > -->
        </template>
      </el-table-column>
      <!--            <el-table-column label="操作">-->
      <!--                <template #default="scope">-->
      <!--                    <el-button size="mini" @click="open(scope.row.id)">查看包月</el-button>-->
      <!--                    <el-button size="mini" @click="pay(scope)">充值</el-button>-->
      <!--                </template>-->
      <!--            </el-table-column>-->
    </el-table>
    <page :current="current" :size="size" :total="total" />
    <MemberAllMonthly
      :dialog="MemberAllMonthly"
      :member-id="id"
      member-type="1"
    />

    <el-dialog
      width="20%"
      :visible.sync="editEndLineDialogState"
      title="修改包月信息"
      :fullscreen="isMobile"
    >
      <el-form
        ref="editMonthlyDateObj"
        :model="editMonthlyDateObj"
        label-width="auto"
        :rules="editMonthlyRules"
      >
        <el-form-item label="手机号码/电卡">
          <el-input
            :value="
              phoneOrCard(currentRow) === '0'
                ? '未绑定'
                : phoneOrCard(currentRow)
            "
            readonly
          ></el-input>
        </el-form-item>

        <el-form-item
          v-if="currentRow.type != 3"
          label="充电剩余时长"
          prop="freeChargeNum"
        >
          <el-input
            v-model="editMonthlyDateObj.freeChargeNum"
            placeholder="请输入"
            type="number"
            min="0"
          >
          </el-input>
        </el-form-item>

        <el-form-item
          v-if="currentRow.type != 3"
          label="充电到期时间"
          prop="chargeMonthlyDate"
        >
          <el-date-picker
            v-model="editMonthlyDateObj.chargeMonthlyDate"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            placeholder="请选择"
            value-format="timestamp"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item
          v-if="currentRow.type != 1"
          label="停车到期时间"
          prop="carMonthlyDate"
        >
          <el-date-picker
            v-model="editMonthlyDateObj.carMonthlyDate"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            placeholder="请选择"
            value-format="timestamp"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editEndLineDialogState = false">取消</el-button>
        <el-button type="primary" @click="handleEditMonthlyDateClick"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <add-charge-monthly-user-dialog
      v-if="addChargeMonthlyUserDialog"
      :dialog="addChargeMonthlyUserDialog"
    />

    <!-- <el-dialog
      width="20%"
      :visible.sync="editEndLineDialogState"
      title="修改包月日期"
    >
      <el-form
        ref="editEndLineParams"
        :model="editEndLineParams"
        label-width="auto"
      >
        <el-form-item label="手机号">
          <el-input v-model="chooseItem.phone" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="充电次数">
          <el-input v-model="editEndLineParams.numberOfCharges"></el-input>
        </el-form-item>
        <el-form-item label="充电到期" v-if="chooseItem.endTime">
          <el-date-picker
            v-model="chargeEndLine"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            placeholder="到期日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="停车到期" v-if="chooseItem.carportMemberMonthly">
          <el-date-picker
            v-model="chooseEndLine"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            placeholder="到期日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editEndLineDialogState = false">取消</el-button>
        <el-button type="primary" @click="editEndLineDo">确定</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import MemberAllMonthly from "@/components/Dialog/MemberAllMonthly";
import createdMixin from "@/mixin/createMixin";
import dialogMixin from "@/mixin/dialogMixin";
import pageMixin from "@/mixin/pageMixin";
import resDispose from "@/mixin/resDisposeMixin";
import searchMixin from "@/mixin/searchMixin";
import { checkPhone } from "@/utils/check";
// import getsTheListOfWeChatUserForTheOpenMonthlySubscription
//   from "@/api/device/member-monthly-manage/getsTheListOfWeChatUserForTheOpenMonthlySubscription";
// import getAllMemberMonthly from "@/api/device/member-monthly-manage/getAllMemberMonthly";
import MemberMonthlyController from "@/api/device/member-monthly-manage/MemberMonthlyController";
import agentEditMonthlyDate from "@/api/device/member-monthly-manage/agentEditMonthlyDate";
import agentGetAllMonthlyVIP from "@/api/device/member-monthly-manage/agentGetAllMonthlyVIP";
import AddChargeMonthlyUserDialog from "@/components/Dialog/addChargeMonthlyUserDialog";
import Page from "@/components/Page";
import SearchByMemberAndCard2 from "@/components/SearchByMemberAndCard2";
import getUserMixin from "@/mixin/getUserMixin";
import isMobileMixin from "@/mixin/isMobileMixin";
import timeMixin from "@/mixin/timeMixin";
import { Message } from "element-ui";

export default {
  name: "UserManageTwo",
  components: {
    MemberAllMonthly,
    Page,
    SearchByMemberAndCard2,
    AddChargeMonthlyUserDialog,
  },
  mixins: [
    resDispose,
    createdMixin,
    pageMixin,
    dialogMixin,
    searchMixin,
    timeMixin,
    getUserMixin,
    isMobileMixin,
  ],
  props: {
    // 是否来自用户详情页面
    isFromUserDeatil: {
      type: Boolean,
      default: false,
    },
    // 用户详情手机号
    detailPhone: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      addChargeMonthlyUserDialog: false,
      id: undefined,
      moneyRules: {
        money: [
          { required: true, message: "请输入充值金额", trigger: "change" },
          {
            type: "number",
            message: "充值金额必须为数字值",
            trigger: "change",
          },
        ],
      },
      rules: {
        phone: checkPhone,
      },
      nickName: undefined,
      MemberAllMonthly: undefined,
      params: {
        pageNum: undefined,
        size: 10,
        phone: undefined,
        memberType: undefined,
        sortName: "id",
        sortType: "DESC",
      },
      editEndLineDialogState: false,
      chargeEndLine: "",
      editEndLineParams: {
        endLine: "",
        numberOfCharges: 0,
        memberMonthlyId: "",
      },
      chooseItem: {
        phone: "",
      },
      chooseEndLine: "",
      records: [],
      editMonthlyDateObj: {
        chargeMonthlyId: undefined,
        chargeMonthlyDate: undefined,
        carMonthlyId: undefined,
        carMonthlyDate: undefined,
        freeChargeNum: undefined,
      },
      currentRow: {},
      editMonthlyRules: {
        chargeMonthlyDate: [
          {
            required: true,
            message: "请选择充电到期时间",
            trigger: ["blur", "change"],
          },
        ],
        carMonthlyDate: [
          {
            required: true,
            message: "请选择停车到期时间",
            trigger: ["blur", "change"],
          },
        ],
        freeChargeNum: [
          {
            required: true,
            message: "请输入充电剩余时长",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    // 新增充电包月用户
    handleAddChargeMonthlyUserBtnClick() {
      this.addChargeMonthlyUserDialog = true;
    },
    // 点击修改包月结束日期时触发
    handleEditMonthlyDate(row) {
      this.currentRow = { ...row };
      console.log(row, 888);
      if (row.type != 3) {
        this.editMonthlyDateObj.chargeMonthlyId = row.source.id;
        this.editMonthlyDateObj.chargeMonthlyDate = row.source.endTime * 1000;
        this.editMonthlyDateObj.freeChargeNum = Math.max(
          row.source.freeChargeNum,
          0
        );
      }
      if (row.type != 1) {
        this.editMonthlyDateObj.carMonthlyId =
          row.type == 2 ? row.source.carportMemberMonthly.id : row.source.id;
        this.editMonthlyDateObj.carMonthlyDate =
          row.type == 2
            ? row.source.carportMemberMonthly.endTime * 1000
            : row.source.endTime * 1000;
      }
      this.editEndLineDialogState = true;
    },
    // 点击修改包月日期确定按钮时触发
    handleEditMonthlyDateClick() {
      this.$refs["editMonthlyDateObj"].validate((valid) => {
        if (valid) {
          const DTO = { ...this.editMonthlyDateObj };
          DTO.chargeMonthlyDate = Math.floor(
            new Date(DTO.chargeMonthlyDate).setHours(23, 59, 59, 999) / 1000
          );
          DTO.carMonthlyDate = Math.floor(
            new Date(DTO.carMonthlyDate).setHours(23, 59, 59, 999) / 1000
          );
          agentEditMonthlyDate(DTO).then((res) => {
            console.log(res, 999);
            if (res.code == 1) {
              Message.success(res.msg);
              this.editEndLineDialogState = false;
              this.fetchData();
            } else {
              Message.error(res.msg);
            }
          });
        }
      });
    },
    sort_change(e) {
      this.params.sortName = e.prop;
      this.params.sortType = e.order == "descending" ? "DESC" : "ASC";
      if (e.order == null) {
        this.params.sortName = null;
        this.params.sortType = null;
      }
      // console.log(this.params.sortName)
      // console.log(this.params.sortType)
      this.fetchData();
    },
    closeReadOnly(val) {
      this.$nextTick(() => {
        if (!val) {
          const timer = setTimeout(() => {
            document.getElementById("el-select").removeAttribute("readonly");
            clearTimeout(timer);
          }, 200);
        }
      });
    },
    open(id) {
      this.MemberAllMonthly = true;
      this.id = id;
    },
    fetchData() {
      this.loadTable = true;
      this.params.pageNum = this.current;
      this.params.size = this.size;
      // console.log(this.params)
      // getsTheListOfWeChatUserForTheOpenMonthlySubscription(this.params).then(res => {
      // getAllMemberMonthly(this.params);

      if (this.isFromUserDeatil) {
        this.params.phone = this.detailPhone;
      }

      agentGetAllMonthlyVIP(this.params)
        .then((res) => {
          this.total = res.data.total;
          this.records = res.data.records;
          // console.log(this.records)
        })
        .finally(() => {
          this.loadTable = false;
        });
    },
    skip(id) {
      this.$router.push({ path: "/User/userManage/" + id });
    },
    clickEditEndLine(row) {
      // console.log(row)
      this.chooseItem = row;
      this.editEndLineParams.numberOfCharges = row.freeChargeNum;
      this.editEndLineParams.memberMonthlyId = row.id;
      this.editEndLineDialogState = true;
      if (row.carportMemberMonthly)
        this.chooseEndLine = new Date(row.carportMemberMonthly.endTime * 1000);
      if (row.endTime) this.chargeEndLine = new Date(row.endTime * 1000);
    },
    editEndLineDo() {
      if (this.chooseEndLine)
        this.editEndLineParams.chargeEndLine =
          this.chooseEndLine.getTime() / 1000;
      if (this.chargeEndLine)
        this.editEndLineParams.endLine = this.chargeEndLine.getTime() / 1000;
      MemberMonthlyController.adminEditMemberMonthlyEndLine(
        this.editEndLineParams
      ).then((res) => {
        this.resFetch({ res });
        this.editEndLineDialogState = false;
      });
    },
  },
  computed: {
    phoneOrCard() {
      return function (row) {
        if (row.phone != null) return row.phone;
        if (row.user != null) return row.user.phone;
        // switch (row.memberType) {
        //   case '1':
        //     return row.phone;
        //   case '3':
        //     return row.memberInfo.phone;
        // }
      };
    },
  },
};
</script>

<style scoped>
.img {
  width: 30px;
  height: 30px;
}
</style>
